<template>
  <v-container>
    <div class="lowest_fares" v-if="min_mode !== true">
      <div v-show="loadingLowest === true" class="loading">
        <pulse-loader :loading="loadingLowest"></pulse-loader>
      </div>
      <div v-show="loadingLowest === false && lowestFaresList.length > 0">
        <v-layout row justify-space-between>
          <v-flex
            xs1
            shrink
            class="btn left"
            justify-center
            align-content-center
            v-if="checkNextDate('left') === true"
            @click="rowShift('left')"
          >
            <v-icon large>
              chevron_left
            </v-icon>
          </v-flex>
          <v-flex
            xs2
            :class="{ 'fare_link': true, selected: checkSelected(fare.date) }"
            v-for="(fare, i) in lowestFaresList"
            :key="i"
          >
            <v-layout
              column
              justify-center
              :class="{ selected: checkSelected(fare.date), 'py-2': true }"
              @click="selectDate(fare.date)"
            >
              <v-flex class="day">{{ getDay(fare.date) }}</v-flex>
              <v-flex class="month">{{ getMonth(fare.date) }}</v-flex>
              <div v-if="fare.price !== 'N/A'">
                <v-flex class="price">{{ fare.price }}</v-flex>
              </div>
              <div v-else>
                <v-flex class="n_a">N/A</v-flex>
              </div>
            </v-layout>
          </v-flex>
          <v-flex
            xs1
            shrink
            class="btn right"
            align-content-center
            @click="rowShift('right')"
          >
            <div v-if="checkNextDate('right') === true">
              <v-icon large>
                chevron_right
              </v-icon>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>

<script>
import store from "../store";
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import dayjs from "dayjs";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "LowestFares",
  store: store,
  computed: {
    loadingLowest: {
      get() {
        return store.state.loadingLowest;
      },
      set() {
        console.log("do not set loading here");
      }
    },
    thisFlightType() {
      return this.getDir() === "R" ? "returning" : "departing"
    },
    min_mode() {
      return store.state.minMode;
    },
    lowestFaresList() {
      if (this.min_mode !== true) {
        if (store.state.lowestFares[this.getDir()] !== undefined) {
          const fares = store.state.lowestFares[this.getDir()];
          if (fares.error === undefined) {
            const max = fares.length - 1;
            let lFares = [];
            for (let x = 0; x < fares.length; x++) {
              lFares.push(fares[x]);
            }
            return lFares;
          }
        }
      }
      return [];
    }
  },
  mixins: [Shared, BookingFormMixin],
  components: { PulseLoader }
};
</script>

<style lang="scss" scoped>
@import "@/styles/flight_search.scss";
</style>
